function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.7049 8.70777L13.7061 15.7066C13.0812 16.3315 11.998 15.8941 11.998 14.9984V10.9991H6.33228C5.77821 10.9991 5.33245 10.5533 5.33245 9.99923V5.99989C5.33245 5.44582 5.77821 5.00006 6.33228 5.00006H11.998V1.00072C11.998 0.109201 13.077 -0.332392 13.7061 0.292504L20.7049 7.29134C21.0923 7.68294 21.0923 8.31617 20.7049 8.70777ZM7.99867 15.4983V13.8319C7.99867 13.557 7.77371 13.332 7.49875 13.332H3.99934C3.26196 13.332 2.66622 12.7363 2.66622 11.9989V4.00022C2.66622 3.26284 3.26196 2.66711 3.99934 2.66711H7.49875C7.77371 2.66711 7.99867 2.44215 7.99867 2.16719V0.500803C7.99867 0.225849 7.77371 0.000886044 7.49875 0.000886044H3.99934C1.79137 0.000886044 0 1.79226 0 4.00022V11.9989C0 14.2069 1.79137 15.9982 3.99934 15.9982H7.49875C7.77371 15.9982 7.99867 15.7733 7.99867 15.4983Z",
  fill: "white"
});

function SvgSignOut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOut);
export default __webpack_public_path__ + "static/media/sign-out.741a8ba7.svg";
export { ForwardRef as ReactComponent };